import { ICopyable } from '../controls/common/icopyable';
import { IArticle } from './interfaces/article.interface';

export class Article implements ICopyable<Article> {
    public id: number = null;
    public code: string = null;
    public designation1: string = null;
    public designation2: string = null;
    public unitPrice: number = null;

    get editableId(): string | number {
        return this['id'];
    }

    public createCopy(): Article {
        const instance = new Article();
        instance.id = this.id;
        instance.code = this.code;
        instance.designation1 = this.designation1;
        instance.designation2 = this.designation2;
        instance.unitPrice = this.unitPrice;

        return instance;
    }

    public static createFormCopy(article: Article): IArticle {
        const instance = new Article();
        instance.id = article.id;
        instance.code = article.code;
        instance.designation1 = article.designation1;
        instance.designation2 = article.designation2;
        instance.unitPrice = article.unitPrice;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.code = other.code;
        this.designation1 = other.designation1;
        this.designation2 = other.designation2;
        this.unitPrice = other.unitPrice;
    }

    public getDisplayName() {
        return `${this.code}`;
    }
}
